import React, {lazy, Suspense} from "react";
import {BrowserRouter as Router, Routes, Route, Navigate, useNavigationType} from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import AdminLayout from "./components/AdminLayout";
import AdminDashboard from "./pages/AdminDashboard";
import ManageEvents from "./pages/ManageEvents";
import Analytics from "./pages/Analytics";
import Settings from "./pages/Settings";
import AdminLogin from "./pages/AdminLogin";
import UsersData from "./pages/UsersData";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import ScanTicket from "./pages/ScanTicket";
import { jwtDecode } from "jwt-decode";
import { useState } from "react";
import NProgressHandler from './components/NProgressHandler'; // <-- Import here
import SuspenseLoader from "./components/SuspenseLoader"; // <-- ADD this import
import UsherLogin from "./pages/UsherLogin"; // 👈 Import the new component
import './App.css'; // <-- MAKE SURE this comes AFTER


const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const EventDetails = lazy(() => import("./pages/EventDetails"));
const Checkout = lazy(() => import("./pages/Checkout"));
const TicketCheck = lazy(() => import("./pages/TicketCheck"));
const Success = lazy(() => import("./pages/Success"));


const RequireAdminAuth = ({ children, loginStatus }) => {
    if (!loginStatus) {
        return <AdminLogin />;
    }

    const token = localStorage.getItem("token");

    try {
        const decoded = jwtDecode(token);
        if (decoded.role === "admin") {
            return children;
        } else {
            return <AdminLogin />;
        }
    } catch (error) {
        console.error("❌ Invalid token:", error);
        return <AdminLogin />;
    }
};

const TrackPageView = () => {
    const location = useLocation();

    useEffect(() => {
        const logPageVisit = async () => {
            try {
                const userId = localStorage.getItem("userId");
                const pageVisited = location.pathname === "/" ? "/home" : location.pathname;

                await axios.post(`${process.env.REACT_APP_API_URL}/api/users/activity`, {
                    userId,
                    page: pageVisited
                });

            } catch (error) {
                console.error("Error tracking page visit:", error);
            }
        };

        logPageVisit();
    }, [location]);

    return null;
};


function App() {
    const [loginStatus, setLoginStatus] = useState(!!localStorage.getItem("token"));

    return (
        <Router>
           <NProgressHandler />
            <Navbar />
            <TrackPageView />
            <Suspense fallback={<SuspenseLoader />}>
            <Routes>
                <Route path="/" element={<Navigate to="/home" replace />} />
                <Route path="/home" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/event/:slug" element={<EventDetails />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/ticket-check" element={<TicketCheck />} />
                <Route path="/success" element={<Success />} />

                <Route path="/admin/login" element={<AdminLogin setLoginStatus={setLoginStatus} />} />
                <Route path="/usher/login" element={<UsherLogin />} />
                <Route path="/admin/scan-ticket" element={<ScanTicket />} />

                {/* Protect Admin Routes */}
                <Route path="/admin" element={<RequireAdminAuth loginStatus={loginStatus}><AdminLayout /></RequireAdminAuth>}>
                    <Route path="dashboard" element={<AdminDashboard />} />
                    <Route path="events" element={<ManageEvents />} />
                    <Route path="analytics" element={<Analytics />} />
                    <Route path="users" element={<UsersData />} />
                    <Route path="settings" element={<Settings />} />
                </Route>
            </Routes>
            </Suspense>
            {!window.location.pathname.startsWith("/admin") && <Footer />}
        </Router>
    );
}

export default App;
